import { ActionButton } from '@react-spectrum/s2';
import Add from '@react-spectrum/s2/icons/Add';
import ChevronDoubleLeft from '@react-spectrum/s2/icons/ChevronDoubleLeft';
import { iconStyle } from '@react-spectrum/s2/style' with { type: 'macro' };

import { ShortcutTooltip } from '@/components/ShortcutTooltip.tsx';
import { trackEvent } from '@/utils/fullstory';

interface ChatHeaderProps {
	onNewChat: () => void;
	onCollapse?: () => void;
}

export const ChatHeader = ({ onNewChat, onCollapse }: ChatHeaderProps) => {
	const handleNewChat = () => {
		trackEvent('Chat Created');
		onNewChat();
	};

	return (
		<div className="flex w-full items-center justify-end gap-2">
			{onCollapse && (
				<ActionButton
					isQuiet
					onPress={onCollapse}
					aria-label="Collapse chat panel"
				>
					<ChevronDoubleLeft styles={iconStyle({ size: 'M' })} />
				</ActionButton>
			)}
			<div className="group relative">
				<button
					type="button"
					onClick={handleNewChat}
					aria-label="New chat"
					className="flex h-8 items-center gap-1 rounded-md px-2
						text-[var(--text-primary)] transition-colors
						hover:bg-[var(--glass-bg-hover)]"
				>
					<Add styles={iconStyle({ size: 'M' })} />
					<span className="text-sm font-medium">New Chat</span>
				</button>
				<ShortcutTooltip label="New chat" shortcut="⌘ J" placement="left" />
			</div>
		</div>
	);
};
